import {
    Component,
    ContentChildren,
    HostBinding,
    Input,
    QueryList
} from '@angular/core';
import { Layout } from '../../baseObjects/layout';

// components
import { ToolbarItemComponent } from './nested/item/toolbar-item.nested';

@Component({
    selector: 'toolbar',
    templateUrl: 'toolbar.component.html',
    host: { 'class': 'toolbar component' }
})
export class ToolbarComponent extends Layout {
    // properties
    toolbarItemsBefore: ToolbarItemComponent[] = [];
    toolbarItemsCenter: ToolbarItemComponent[] = [];
    toolbarItemsAfter: ToolbarItemComponent[] = [];

    // io
    @Input() @HostBinding('class.toolbar-collapse') collapsable: boolean;
    private _fixPostion: string;
    @Input() set fixPostion(value: string) { // top, right, bottom, left
        switch (value) {
            case 'top':
                this._toolbarFixTop = true;
                this._toolbarFixRight = false;
                this._toolbarFixBottom = false;
                this._toolbarFixLeft = false;
                break;
            case 'right':
                this._toolbarFixTop = false;
                this._toolbarFixRight = true;
                this._toolbarFixBottom = false;
                this._toolbarFixLeft = false;
                break;
            case 'bottom':
                this._toolbarFixTop = false;
                this._toolbarFixRight = false;
                this._toolbarFixBottom = true;
                this._toolbarFixLeft = false;
                break;
            case 'left':
                this._toolbarFixTop = false;
                this._toolbarFixRight = false;
                this._toolbarFixBottom = false;
                this._toolbarFixLeft = true;
                break;
            default:
                this._toolbarFixTop = false;
                this._toolbarFixRight = false;
                this._toolbarFixBottom = false;
                this._toolbarFixLeft = false;
                break;
        }
    }
    private _toolbarItems: ToolbarItemComponent[];
    get toolbarItems(): ToolbarItemComponent[] {
        return this._toolbarItems;
    }
    @Input() set toolbarItems(value: ToolbarItemComponent[]) {
        this._toolbarItems = value;
        if (this._toolbarItems) {
            this._toolbarItems.forEach(toolbarItem => {
                switch (toolbarItem.location) {
                    case 'center':
                        this.toolbarItemsCenter.push(toolbarItem);
                        break;
                    case 'after':
                        this.toolbarItemsAfter.push(toolbarItem);
                        break;
                    default:
                        this.toolbarItemsBefore.push(toolbarItem);
                        break;
                }
            });
        }
    }
    // host bindings
    @HostBinding('class.toolbar-fixed-top') private _toolbarFixTop: boolean;
    @HostBinding('class.toolbar-fixed-right') private _toolbarFixRight: boolean;
    @HostBinding('class.toolbar-fixed-bottom') private _toolbarFixBottom: boolean;
    @HostBinding('class.toolbar-fixed-left') private _toolbarFixLeft: boolean;
    // content children
    @ContentChildren(ToolbarItemComponent) set toolbarItemComponents(value: QueryList<ToolbarItemComponent>) {
        this.toolbarItems = this.toolbarItems ? this.toolbarItems : value.toArray();
    }
}



// WEBPACK FOOTER //
// ./client-src/app/core/components/toolbar/toolbar.component.ts